import React, { useEffect, useRef } from "react"
import "@grapecity/spread-sheets-designer-resources-en"
import "@grapecity/spread-sheets-designer/styles/gc.spread.sheets.designer.min.css"
import "@grapecity/spread-sheets/styles/gc.spread.sheets.excel2013white.css"
import GC from "@grapecity/spread-sheets"
import GCD from "@grapecity/spread-sheets-designer"
import { Designer } from "@grapecity/spread-sheets-designer-react"
import axios from "axios"
import { API_ROUTE, generateTextFromSpreadsheet } from "../../../utils"

const key =
    "app.pretzel.space,457378169513262#B0w0WTidDUiJUWkVWa8o7bRhlMopGRrsSMhNTUylDT62WRmZWOMJHU03EaONTdmRGMOdFN4gFSUlnd9ZzRtFTMwM4LO3yV8Z7MEVXdL9mc0JXRnxEWlRlclFVc6MXb5ImQM94VLJkS93SSjplekxmRM3UVK5EZk96UJZ4K7g5KhhGTqNjZZJlbulDbIZjYppXWatGewZDN9lXcQZXcyR6QGZVVaBXek56MxJkS62WSmhzVml4TVJGS6tWb9pWYyc6VzQGc4FTeiF5STJ4c7ZUQ9QWbjl6Szcma6ZlR9UzS7FVTypmWrAldhdmI0IyUiwiI4EkNDJEMwMjI0ICSiwCMyIjNyQjMxYTM0IicfJye35XX3JSW6U4NiojIDJCLiQTMuYHIu3GZkFULyVmbnl6clRULTpEZhVmcwNlI0IiTis7W0ICZyBlIsIiM5QDMyADI4IDOwEjMwIjI0ICdyNkIsISZjFGcz9CblpHdlJHcuAHchJiOiMXbEJCLikHanFGbsFGUgwWdhBlI0ISYONkIsIiM6IzMxUTO6EDO7MzN5QjI0ICZJJye0ICRiwiI34TUEhkdXJUUnNnW6RWY6dEa9pUOwE4KLBFe7FFarYTevUTcyYWWBlXWy2GUvJTRQNlMXpVMqRlcoNUU9siThRkUaZWUvNETJBXNMN6YHZFTBd4UKlXdrkHUTZjZ8EFeT3SaxkXStN4QjhEUuxyS"
GCD.Spread.Sheets.Designer.LicenseKey = key
GC.Spread.Sheets.LicenseKey =
    "app.pretzel.space,553379915413553#B0yXCiNVNo9GW6o7ZiVGR88ES8VWV0lHcjRmTRNzZLB7YS9EbKVGNvcVQtpkZrVTVzVHTRNWUxoWNwh6KvBjTYJ4TvJkULJ6R6h7VQFTWT3UaX5URxQmQvdkMPNWSEhjWoRDRLF7dw26VGdjQodjcqJ6K5dWU8wkTqdlSm3GenVmN9YzLqFjWBBDaClncycUOygHWy9kcJx4Tx3yL7s6MTVjenBFUV3mephkYyBncI9Ucjl5VxgDTVxWOlNUWMlUbsJHd7MkT8E4MCl4SFNFcZl6S6tUa8N7R7kUOlRWdzhEcMBTOmdWcFtCTBR7bxYUepFlI0IyUiwiI6MzM5EDMwIjI0ICSiwCN6gzN6MDNxETM0IicfJye&Qf35VfiUURJZlI0IyQiwiI4EjL6BCITpEIkFWZyB7UiojIOJyebpjIkJHUiwiI7MDO5MDMgkDM8ATMyAjMiojI4J7QiwiIlNWYwNnLsVme4Vmcw9CcwFmI0IyctRkIsISeodWYsxWYQBCb5FGUiojIh94QiwiIzUTNzEDN5ETO9czMzUTNiojIklkIs4XXbpjInxmZiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34zZ7YmVN3mcatSOpBHR9JVZHdjN4RWU7FlYCVUdDF7SvgVdhhnWwokRpVnVrt6KCdzNk9kR9F4a6MFcG9UbTNEevpEUPVUZLBXY9M4Mj3WNxVjW8siWNBlbQxWRGB7L6hTTSCWvv"

const Events = GC.Spread.Sheets.Events
const Excel: React.FC<{
    setRawContext: any
    appSpaceContent: string
    activeAppSpace: any
    onLoad: any
}> = ({ onLoad, setRawContext, appSpaceContent, activeAppSpace }) => {
    const currentWorkbook = useRef<any>(null)
    const saveTimeoutRef = useRef<NodeJS.Timeout>()

    const saveChanges = (newContent: any) => {
        const betterFormat = generateTextFromSpreadsheet(JSON.parse(newContent))
        console.log(betterFormat)
        setRawContext(betterFormat)

        axios.post(`${API_ROUTE}/update-file`, {
            fileId: activeAppSpace.fileId,
            content:
                activeAppSpace.type === "sheetx"
                    ? newContent
                    : `data:text/plain;base64,${btoa(newContent)}`,
        })
    }

    const debouncedSaveChanges = (newContent: any) => {
        if (saveTimeoutRef.current) {
            clearTimeout(saveTimeoutRef.current)
        }
        saveTimeoutRef.current = setTimeout(() => {
            saveChanges(newContent)
        }, 2500) // Save after inactivity
    }

    useEffect(() => {
        if (appSpaceContent) {
            const workbook = currentWorkbook.current
            if (workbook) {
                workbook.fromJSON(JSON.parse(appSpaceContent))
            }
        }
    }, [appSpaceContent])

    const designerInitializedCallback = (designer: any) => {
        const workbook = designer.getWorkbook()
        workbook.fromJSON(JSON.parse(appSpaceContent))

        const events = [
            Events.ActiveSheetChanged,
            Events.CellChanged,
            Events.ColumnChanged,
            Events.ColumnWidthChanged,
            Events.CommentChanged,
            Events.CommentRemoved,
            Events.DragDropBlockCompleted,
            Events.DragFillBlockCompleted,
            Events.DragMerged,
            Events.EditEnded,
            Events.FloatingObjectChanged,
            Events.FloatingObjectLoaded,
            Events.FloatingObjectRemoved,
            Events.LeftColumnChanged,
            Events.RowChanged,
            Events.ShapeChanged,
            Events.ShapeRemoved,
            Events.SheetChanged,
            Events.SheetMoved,
            Events.SheetNameChanged,
            Events.TableColumnsChanged,
            Events.TableRowsChanged,
            Events.TopRowChanged,
            Events.UserFormulaEntered,
            Events.ValueChanged,
            Events.ClipboardPasted,
        ]

        events.map((e) =>
            workbook.bind(e, () => debouncedSaveChanges(JSON.stringify(workbook.toJSON())))
        )

        currentWorkbook.current = workbook
        onLoad()
    }
    return (
        <Designer
            designerInitialized={designerInitializedCallback}
            styleInfo={{ width: "100%", height: "calc(100vh - 50px)" }}
        />
    )
}

export default Excel
